export interface IViewValue {
  view: string;

  value: string;
}

const VIEW_VALID_SYMBOLS: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', ' ', '.', '(', ')', '+'];
const VALUE_VALID_SYMBOLS: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export function parsePhoneNumber(inputValue: string): IViewValue {
  const result: IViewValue = {
    view: inputValue,
    value: inputValue,
  };

  for (const symbol of inputValue) {
    if (VIEW_VALID_SYMBOLS.indexOf(symbol) < 0) {
      result.view = result.view.replace(symbol, '');
    }
    if (VALUE_VALID_SYMBOLS.indexOf(symbol) < 0) {
      result.value = result.value.replace(symbol, '');
    }
  }

  if (result.value) {
    result.value = `+${result.value}`;
  } else {
    result.value = result.view;
  }
  return result;
}

export function isIncludeOnlyValidPhoneNumberSymbols(value: string): boolean {
  let result = true;
  for (const symbol of value) {
    if (VIEW_VALID_SYMBOLS.indexOf(symbol) < 0) {
      result = false;
    }
  }
  return result;
}
